// MOD-08 — SEO anahtar kelime string <-> dizi dönüşümü. Saf yardımcılar
// (bileşenden ayrı tutulur; birim test edilebilir + Fast Refresh dostu).

/** Virgül-ayrık string'i trim'lenmiş, tekrarsız token'lara böler. */
export function parseKeywords(value: string | null | undefined): string[] {
  if (!value) return [];
  const seen = new Set<string>();
  const tokens: string[] = [];
  for (const raw of value.split(',')) {
    const token = raw.trim();
    if (token.length === 0) continue;
    const dedupeKey = token.toLocaleLowerCase('tr');
    if (seen.has(dedupeKey)) continue;
    seen.add(dedupeKey);
    tokens.push(token);
  }
  return tokens;
}

/** Token'ları normalize edilmiş virgül-ayrık string'e birleştirir (boşsa null). */
export function joinKeywords(tokens: readonly string[]): string | null {
  const normalized = parseKeywords(tokens.join(','));
  return normalized.length > 0 ? normalized.join(', ') : null;
}
